
<template>
  <div>
    <div v-if="routeText">
			<h3>{{ getMetaTitle }}</h3>
      <p v-html="routeText"></p>
			<div v-if="showReturnButton">
        <back-button></back-button>
      </div>
    </div>
    <div v-else>
      <login></login>
    </div>
  </div>
</template>

<script>
import Login from '@/components/views/account/LoginOrRegister'
import BackButton from '@/components/base/buttons/BackButton'
import layoutMixin from '@/mixins/layout.mixin'

export default {
	mixins: [layoutMixin],
  components: {
    BackButton,
    Login
  },
  computed: {
    routeText () {
      return this.$store.state.errorPageMessage
    },
		showReturnButton () {
			return !!this.$route.query.returnUrl && this.$store.getters['session/isLogged']
		}
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/views/errors/UnauthorizedErrorPage.vue